/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query RateReadQuery($type: CUSTOMER_TYPE,  $skip: Int) {
  RateRead(type: $type, take:10000, skip: $skip) {
    id,
    displayName,
    type,
    message
    status
  }
}
`
